import { LoaderCircle } from "lucide-react";

/**
 * Full-screen "signing you in" overlay shown during the OIDC redirect legs, so
 * the user sees a calm spinner instead of the login form flashing between hops.
 *
 * The social-login ceremony is a chain of full-page navigations —
 * `<host>/login?social-start=1` → the provider → the fixed apex callback →
 * `<apex>/login?id=…` → the final club/admin host. Two of those legs re-mount
 * `/login`; without this the login form (or an empty panel) paints for a beat
 * on each. Rendering this instead — keyed on `socialStartProvider` /
 * `socialReturnRequested` in LoginPage — keeps the transition seamless.
 */
export function AuthTransitionScreen({
  message = "Signing you in…",
}: {
  message?: string;
}) {
  return (
    <main
      data-testid="auth-transition"
      aria-busy="true"
      className="flex min-h-[calc(100svh-4rem)] flex-col items-center justify-center gap-4 bg-canvas px-4 text-center"
    >
      <LoaderCircle
        size={28}
        strokeWidth={2}
        aria-hidden="true"
        className="animate-spin text-accent"
      />
      <p role="status" className="text-sm text-ink-muted">
        {message}
      </p>
    </main>
  );
}
